module.exports = __webpack_public_path__ + "static/media/simpledb-createindex.43088cc9.png";